import useDebounce from "hooks/others/useDebounce";
import { ClientRequestsModel } from "models/clientRequests";
import { useQuery } from "react-query";
import { FetchClientRequests } from "services/clientRequests";
import { ApiError } from "utils/api/models/api-error";
import ApiResult from "utils/api/models/api-result";
// import { useAppSelector } from "store";

export default function useClientRequests(
  page: number,
  StatusFliter: any,
  requestStatusFilter: any,
  StatusPriority: any,
  DateRange: any,
  SearchBy: any,
  SearchText: any,
  isActive: any,
  sort: any,
  copmanyPlace: any,
  myTickets: number,
  filterDateBy: string,
  isPaused?: 0 | 1,
  arrchived?: string | number
) {
  const { newParam: searchParam } = useDebounce(SearchText);

  const queryKey = [
    "clientRequests",
    page,
    StatusFliter,
    requestStatusFilter,
    StatusPriority,
    DateRange,
    SearchBy,
    searchParam,
    isActive,
    sort,
    copmanyPlace,
    myTickets,
    filterDateBy,
    isPaused,
  ];
  return {
    ...useQuery<ApiResult<ClientRequestsModel[]>, ApiError>(
      queryKey,
      () =>
        FetchClientRequests(
          page,
          StatusFliter,
          requestStatusFilter,
          StatusPriority,
          DateRange,
          SearchBy,
          SearchText,
          isActive,
          sort,
          copmanyPlace,
          myTickets,
          filterDateBy,
          isPaused,
          arrchived
        ),
      {
        // staleTime: 30000,
        // refetchOnWindowFocus: false,
        keepPreviousData: true,
      }
    ),
  };
}
